const whiteListMobileSidebar = ['/apps', '/pages', '/contenthub']

export default whiteListMobileSidebar
